import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import SettingsModalField from '../../Shared/Forms/SettingsModalField'
import Button from '../../Shared/Button'
import { verifyOtp } from '../../../utils/io'

class TwoFactorAuthenticationForm extends Component {
  errorMessage = null
  handleSubmit = async ({ authCode }) => {
    const { onSuccess } = this.props
    try {
      const verified = await verifyOtp(authCode)
      if (verified) {
        if (onSuccess) {
          onSuccess()

          return
        }
      }

      this.errorMessage = 'Invalid authentication code. Please try again.'
    } catch (err) {
      this.errorMessage = 'Invalid authentication code. Please try again.'
    }
  }

  render() {
    const { handleSubmit } = this.props

    return (
      <>
        {this.errorMessage && typeof this.errorMessage === 'string' ? (
          <div className="settings-form-alert">{this.errorMessage}</div>
        ) : null}
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Field
            component={SettingsModalField}
            name="authCode"
            label="Authentication Code"
            placeholder="XXXXXX"
            type="number"
          />
          <Button small teal fitContent type="submit">
            Verify & Activate
          </Button>
        </form>
      </>
    )
  }
}

export default reduxForm({
  form: 'twoFactorAuthenticationForm',
})(TwoFactorAuthenticationForm)
